import AssessmentTemplateCardGridItem from "@/shared/components/assessment/AssessmenTemplateCardLayout/AssessmentTemplateCardGridItem";
import AssessmentTemplateCardGrid from "@/shared/components/assessment/AssessmenTemplateCardLayout/AssessmentTemplateCardGrid";
import IndicatorList from "./IndicatorList";
import styles from "./styles.module.css";

interface IndicatorsSectionProps {
  compositeKey: string;
  negativeItems: string[];
  positiveItems: string[];
}

export default function IndicatorsSection({ compositeKey, negativeItems, positiveItems }: IndicatorsSectionProps) {
  return (
    <div style={{ marginTop: 16 }}>
      <AssessmentTemplateCardGrid className={styles.indicatorsGrid}>
        <AssessmentTemplateCardGridItem>
          <IndicatorList
            compositeKey={compositeKey}
            title="Negative Indicators"
            items={negativeItems}
            variant="negative"
          />
        </AssessmentTemplateCardGridItem>
        <AssessmentTemplateCardGridItem>
          <IndicatorList
            compositeKey={compositeKey}
            title="Positive Indicators"
            items={positiveItems}
            variant="positive"
          />
        </AssessmentTemplateCardGridItem>
      </AssessmentTemplateCardGrid>
    </div>
  );
}
